import { useEffect } from 'react';

const APP_SUFFIX = 'Helianthus Arbiter';

/**
 * Sets the browser document title to "{title} - Helianthus Arbiter".
 * Restores the previous title on unmount.
 *
 * @param title - The contextual page title (e.g., "Rules", "Rule: MyRule")
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - ${APP_SUFFIX}` : APP_SUFFIX;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
